import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Reveal content once as it enters the viewport, including filtered products. */
export default function MotionEffects() {
  const { pathname } = useLocation();
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || !('IntersectionObserver' in window)) return;
    const seen = new WeakSet<Element>();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('motion-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06 });
    const discover = () => {
      document.querySelectorAll('[data-product-shop], main > div > aside > div, footer > div:first-child > div, .category-hero, main > div > div:not(.product-listing)').forEach((element, index) => {
        if (seen.has(element)) return;
        seen.add(element);
        (element as HTMLElement).style.setProperty('--reveal-delay', `${(index % 4) * 65}ms`);
        element.classList.add('motion-reveal');
        observer.observe(element);
      });
    };
    discover();
    const mutations = new MutationObserver(discover);
    const main = document.querySelector('main');
    if (main) mutations.observe(main, { childList: true, subtree: true });
    const showAll = () => {
      if (preference.matches) {
        observer.disconnect();
        document.querySelectorAll('.motion-reveal').forEach(el => el.classList.add('motion-visible'));
      }
    };
    preference.addEventListener('change', showAll);
    return () => {
      mutations.disconnect();
      observer.disconnect();
      preference.removeEventListener('change', showAll);
      document.querySelectorAll('.motion-reveal').forEach(el => el.classList.remove('motion-reveal', 'motion-visible'));
    };
  }, [pathname]);
  return null;
}
